import { SubscriptionPackage } from '@bpm-web-app/supreme-api-sdk';

export enum TrackingTarget {
    gtag = 'gtag',
    fbq = 'fbq',
}

export enum EventType {
    conversion = 'conversion',
    purchase = 'purchase',
    signUpStep = 'sign_up_step',
}

interface Options {
    type: EventType;
}

export enum SignUpStep {
    plansPage = 'plans-page',
    paymentForm = 'payment-form',
    success = 'success',
}

export enum ConversionType {
    subscription = 'subscription',
    product = 'product',
    creditPack = 'credit-pack',
}

interface SubscriptionData {
    transaction_id?: string;
    platform?: SubscriptionPackage.PlatformEnum;
    library?: SubscriptionPackage.LibraryEnum;
    value?: string;
    currency?: string;
    plan?: SubscriptionPackage.NameEnum;
    duration?: number;
    promo_code?: string;
    items?: any[]
}

export interface SignUpOptions extends Options {
    type: EventType.signUpStep;
    data: SubscriptionData & {
        step: SignUpStep;
    };
}

export interface ConversionOptions extends Options {
    type: EventType.conversion;
    data: SubscriptionData & {
        type: ConversionType;
        send_to?: string;
    };
}

export interface PurchaseOptions extends Options {
    type: EventType.purchase;
    data: SubscriptionData & {
        type: ConversionType;
        send_to?: string;
        transaction_id: string;
    };
}

type AnyOptions = SignUpOptions | ConversionOptions | PurchaseOptions;

export function fbqTrack(options: { type: string; data?: object }) {
    if ((window as any).fbq) {
        try {
            (window as any).fbq('track', options.type, {
                ...options.data,
            });
            // eslint-disable-next-line no-empty
        } catch (error) { }
    }
}

export function gtagEvent(options: AnyOptions) {
    if ((window as any).dataLayer) {
        try {
            (window as any).dataLayer.push({
                event: options.type,
                ecommerce: {
                    ...options.data,
                }
            });
            // eslint-disable-next-line no-empty
        } catch (error) {

        }
    }
}

export function trackEvent(options: AnyOptions, targets: TrackingTarget[] = [TrackingTarget.fbq, TrackingTarget.gtag]) {
    if (targets.indexOf(TrackingTarget.gtag) !== -1) gtagEvent(options);
    if (targets.indexOf(TrackingTarget.fbq) !== -1) fbqTrack(options);
}
